// extracted by mini-css-extract-plugin
export default {"tableContainer":"Table__tableContainer--3qo","error":"Table__error--1SS","title":"Table__title--2TK","description":"Table__description--1dh"};